import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";

export const getErrorMessage = (error: FetchBaseQueryError | SerializedError) => {
    if (error && 'data' in error) {
        if (typeof (error.data) === 'string') {
            return error.data;
        } else {
            return (error.data as any).detail as string;
        }
    } else {
        return 'An unhandled error has occurred.'
    }
}

/**
 * True when a request failed with HTTP 409 Conflict. The API sends a 409's message as plain text, which
 * fetchBaseQuery fails to parse as JSON, so it reports status 'PARSING_ERROR' and keeps the real code in
 * originalStatus.
 */
export const isConflictError = (error: unknown) => {
    const { status, originalStatus } = (error ?? {}) as { status?: unknown; originalStatus?: unknown };
    return status === 409 || originalStatus === 409;
};
